import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Collapse, Divider, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { SxProps } from "@mui/system";
import { ExpandLess, ExpandMore, ListAlt } from "@mui/icons-material";

import ListItemExtended from "./shared/ListItemExtended";
import { PublicRoutesConfig, CommonRoutesConfig } from "./RoutesConfig";
import useUserContext from "../hooks/useUserContext";

const style: SxProps = {
  pl: 4,
};

export default function Menu() {
  const location = useLocation();
  const { isAuthenticated } = useUserContext();

  const [openRegistersMenu, setRegistersMenu] = useState(false);

  const handleChildMenus = () => {
    [PublicRoutesConfig.Authorization.Search.Path, PublicRoutesConfig.WithdrawnAuthorization.Search.Path].forEach(
      (path) => {
        if (location.pathname.startsWith(path)) {
          setRegistersMenu(true);
        }
      }
    );
  };

  useEffect(() => {
    handleChildMenus();
  }, [location]);

  const publicRoutes = (
    <>
      <List>
        {isAuthenticated && (
          <>
            <ListItemExtended routeItem={PublicRoutesConfig.Home} exact={true} />
            <Divider />
            <ListItem button onClick={() => setRegistersMenu(!openRegistersMenu)}>
              <ListItemIcon>
                <ListAlt />
              </ListItemIcon>
              <ListItemText primary="Регистри" />
              {openRegistersMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openRegistersMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemExtended register={PublicRoutesConfig.Authorization} extraStyles={{ ...style }} />
                <ListItemExtended register={PublicRoutesConfig.WithdrawnAuthorization} extraStyles={{ ...style }} />
              </List>
            </Collapse>
          </>
        )}
        {!isAuthenticated && (
          <>
            <ListItemExtended routeItem={CommonRoutesConfig.Login} />
            <ListItemExtended routeItem={CommonRoutesConfig.Help} />
          </>
        )}
      </List>
    </>
  );

  return publicRoutes;
}
